var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiomasse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "93px",
    height: 80,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 20,
    y: 160,
    width: 160,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "cls-1",
    d: "M94.78,44.22v3.27c0,9.77-2.99,14.4-6.45,19.77-3.77,5.85-8.04,12.47-8.04,25.18s4.27,19.32,8.04,25.16c3.46,5.36,6.45,9.99,6.45,19.74v12.68h10v-12.68c0-12.7-4.27-19.32-8.04-25.16-3.46-5.36-6.45-9.99-6.45-19.74s2.99-14.4,6.45-19.76c3.77-5.85,8.04-12.47,8.04-25.19v-3.35c3.1,3.01,6.89,7,11,11.98l7.71-6.37c-11.23-13.59-20.32-20.38-20.7-20.66l-2.97-2.2-2.97,2.2c-.38,.28-9.47,7.06-20.7,20.66l7.71,6.37c4.07-4.92,7.84-8.89,10.93-11.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "cls-1",
    d: "M34.78,44.21v3.27c0,9.77-2.99,14.4-6.45,19.77-3.77,5.85-8.04,12.47-8.04,25.18s4.27,19.32,8.04,25.16c3.46,5.36,6.45,9.99,6.45,19.74v12.68h10v-12.68c0-12.7-4.27-19.32-8.04-25.16-3.46-5.36-6.45-9.99-6.45-19.74s2.99-14.4,6.45-19.76c3.77-5.85,8.04-12.47,8.04-25.19v-3.34c3.11,3.02,6.9,7.01,11,11.97l7.71-6.37c-11.23-13.59-20.32-20.38-20.7-20.66l-2.97-2.2-2.97,2.2c-.38,.28-9.47,7.06-20.7,20.66l7.71,6.37c4.07-4.92,7.84-8.89,10.93-11.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "cls-1",
    d: "M155.14,44.21v3.27c0,9.77-2.99,14.4-6.45,19.77-3.77,5.85-8.04,12.47-8.04,25.18s4.27,19.32,8.04,25.16c3.46,5.36,6.45,9.99,6.45,19.74v12.68h10v-12.68c0-12.7-4.27-19.32-8.04-25.16-3.46-5.36-6.45-9.99-6.45-19.74s2.99-14.39,6.45-19.76c3.77-5.85,8.04-12.47,8.04-25.19v-3.34c3.11,3.02,6.9,7.01,11,11.97l7.71-6.37c-11.23-13.59-20.32-20.38-20.7-20.66l-2.97-2.2-2.97,2.2c-.38,.28-9.47,7.06-20.7,20.66l7.71,6.37c4.07-4.92,7.84-8.89,10.93-11.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiomasse);
export default __webpack_public_path__ + "static/media/biomasse.dc005364d5e092addb9c34a8292cb8f5.svg";
export { ForwardRef as ReactComponent };